(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const strings = window.afterglowStrings || {};
  let introTimer, introCloseTimer;
  const loader = document.querySelector('[data-af-loader]');
  function finishIntro() {
    clearTimeout(introTimer);
    if (!loader?.open) return;
    loader.classList.add('is-leaving');
    clearTimeout(introCloseTimer);
    introCloseTimer = setTimeout(() => {
      loader.close();
      loader.classList.remove('is-leaving');
    }, reduced.matches ? 0 : 400);
  }
  function showIntro(replay = false) {
    if (!loader || typeof loader.showModal !== 'function') return;
    let seen = false;
    try { seen = sessionStorage.getItem('af-intro-v2') === '1'; sessionStorage.setItem('af-intro-v2', '1'); } catch { /* Storage is optional. */ }
    if (!replay && (seen || window.Shopify?.designMode || location.hash || new URLSearchParams(location.search).has('customer_posted'))) return;
    clearTimeout(introCloseTimer);
    loader.classList.remove('is-leaving');
    loader.showModal();
    introTimer = setTimeout(finishIntro, reduced.matches ? 180 : 1650);
  }
  loader?.querySelector('[data-af-intro-skip]')?.addEventListener('click', finishIntro);
  loader?.addEventListener('cancel', () => { clearTimeout(introTimer); });
  document.querySelectorAll('[data-af-intro-replay]').forEach(button => {
    if (!loader) return;
    button.hidden = false;
    button.addEventListener('click', () => showIntro(true));
  });
  showIntro();

  function wireMenu(scope = document) {
    const menu = scope.querySelector('[data-af-menu]');
    const opener = scope.querySelector('[data-af-menu-open]');
    if (!menu || !opener || opener.dataset.bound) return;
    opener.dataset.bound = 'true';
    const close = () => menu.close();
    opener.addEventListener('click', () => {
      menu.showModal();
      opener.setAttribute('aria-expanded', 'true');
      document.body.classList.add('af-modal-open');
    });
    menu.querySelector('[data-af-menu-close]').addEventListener('click', close);
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
    menu.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...menu.querySelectorAll('a[href],button:not(:disabled)')];
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    menu.addEventListener('click', event => { if (event.target === menu && event.clientX < menu.getBoundingClientRect().left) close(); });
    menu.addEventListener('close', () => {
      opener.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('af-modal-open');
    });
  }
  wireMenu();

  const players = new Map();
  const timeText = time => `${Math.floor(time / 60)}:${Math.floor(time % 60).toString().padStart(2, '0')}`;
  function wirePlayers(scope = document) {
    scope.querySelectorAll('[data-af-player]').forEach(root => {
      if (players.has(root)) return;
      const audio = root.querySelector('[data-af-audio]');
      audio.volume = 0.8;
      const button = root.querySelector('[data-af-play]');
      const label = root.querySelector('[data-af-audio-label]');
      const status = root.querySelector('[data-af-audio-status]');
      const clock = root.querySelector('[data-af-audio-clock]');
      const bars = [...root.querySelectorAll('.af-wave i')];
      const source = root.dataset.fullSource || root.dataset.clipSource;
      const isFull = Boolean(root.dataset.fullSource);
      const start = isFull ? Number(root.dataset.start) || 0 : 0;
      const displayStart = isFull ? start : 88;
      let ctx, analyser, data, frame = 0, loaded = false, disposed = false, request = 0;
      const emit = (playing, energy = 0) => document.dispatchEvent(new CustomEvent('afterglow:audio', { detail: { playing, energy, time: displayStart + Math.max(0, audio.currentTime - start) } }));
      const paint = () => {
        const elapsed = Math.max(0, audio.currentTime - start);
        const length = Math.min(24, Math.max(0, audio.duration - start) || 24);
        clock.textContent = `${timeText(displayStart + elapsed)} — ${timeText(displayStart + length)}`;
        bars.forEach((bar, index) => bar.classList.toggle('is-past', index / bars.length < elapsed / length));
        let energy = 0;
        if (analyser) {
          analyser.getByteFrequencyData(data);
          for (let i = 1; i < 24; i++) energy += data[i] / 255;
          energy /= 23;
        }
        emit(!audio.paused, energy);
        if (!audio.paused && !disposed) frame = requestAnimationFrame(paint);
      };
      const setState = playing => {
        root.classList.toggle('is-playing', playing);
        button.setAttribute('aria-pressed', String(playing));
        button.setAttribute('aria-label', playing ? strings.pauseAudio : strings.playDrop);
        root.querySelector('[data-af-play-icon]').hidden = playing;
        root.querySelector('[data-af-pause-icon]').hidden = !playing;
        label.textContent = playing ? strings.playing : strings.playDrop;
        cancelAnimationFrame(frame);
        if (playing) paint(); else emit(false);
      };
      const fail = () => {
        setState(false);
        status.classList.remove('sr-only');
        status.textContent = strings.audioError;
        button.disabled = false;
      };
      async function play() {
        if (!audio.paused) { audio.pause(); return; }
        players.forEach(player => { if (player.audio !== audio) player.cancel(); });
        const attempt = ++request;
        button.disabled = true;
        status.textContent = strings.loadingAudio;
        try {
          if (!loaded) {
            audio.src = source;
            // A bundled same-origin excerpt can be analysed without exposing an external service.
            if (!isFull && (window.AudioContext || window.webkitAudioContext)) {
              try {
                ctx = new (window.AudioContext || window.webkitAudioContext)();
                analyser = ctx.createAnalyser(); analyser.fftSize = 256;
                data = new Uint8Array(analyser.frequencyBinCount);
                ctx.createMediaElementSource(audio).connect(analyser); analyser.connect(ctx.destination);
              } catch { analyser = null; }
            }
            loaded = true;
          }
          if (ctx?.state === 'suspended') await ctx.resume();
          if (audio.readyState < 1) {
            await new Promise((resolve, reject) => {
              const timer = setTimeout(() => done(new Error('Audio timed out')), 12000);
              const onReady = () => done();
              const onError = () => done(new Error('Audio unavailable'));
              function done(error) { clearTimeout(timer); audio.removeEventListener('loadedmetadata', onReady); audio.removeEventListener('error', onError); error ? reject(error) : resolve(); }
              audio.addEventListener('loadedmetadata', onReady, { once: true });
              audio.addEventListener('error', onError, { once: true });
              audio.load();
            });
          }
          if (disposed || document.hidden || attempt !== request) return;
          if (start >= audio.duration) throw new Error('Start exceeds audio duration');
          if (audio.currentTime < start || audio.currentTime >= Math.min(start + 24, audio.duration) - .1) audio.currentTime = start;
          await audio.play();
          if (disposed || document.hidden || attempt !== request) { audio.pause(); return; }
          status.textContent = '';
          status.classList.add('sr-only');
        } catch { fail(); }
        finally { button.disabled = false; }
      }
      button.addEventListener('click', play);
      audio.addEventListener('play', () => setState(true));
      audio.addEventListener('pause', () => setState(false));
      audio.addEventListener('ended', () => setState(false));
      audio.addEventListener('error', fail);
      audio.addEventListener('timeupdate', () => { if (audio.currentTime >= start + 24) { audio.pause(); audio.currentTime = start; } });
      clock.textContent = `${timeText(displayStart)} — ${timeText(displayStart + 24)}`;
      players.set(root, { audio, cancel() { request++; audio.pause(); }, dispose() { disposed = true; request++; audio.pause(); audio.removeAttribute('src'); audio.load(); cancelAnimationFrame(frame); ctx?.close().catch(() => {}); players.delete(root); } });
    });
  }
  wirePlayers();
  document.addEventListener('visibilitychange', () => { if (document.hidden) players.forEach(player => player.cancel()); });
  window.addEventListener('pagehide', () => players.forEach(player => player.cancel()));

  let sceneModule;
  function loadScenes(scope = document) {
    const scene = scope.querySelector('[data-af-scene]');
    if (!scene) return;
    const stage = scene.closest('[data-af-stage]');
    const toggle = stage?.querySelector('[data-af-scene-toggle]');
    scene.addEventListener('afterglow:scene-ready', () => { if (toggle) toggle.hidden = false; }, { once: true });
    scene.addEventListener('afterglow:scene-error', () => { if (toggle) toggle.hidden = true; }, { once: true });
    if (navigator.connection?.saveData) return;
    const start = () => {
      sceneModule ||= import(scene.dataset.sceneModule);
      sceneModule.then(module => module.initAfterglowScenes(scope)).catch(() => { if (toggle) toggle.hidden = true; });
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); start(); } }, { rootMargin: '150px' });
      observer.observe(scene);
    } else start();
  }
  loadScenes();
  document.addEventListener('shopify:section:load', event => { wireMenu(event.target); wirePlayers(event.target); loadScenes(event.target); });
  document.addEventListener('shopify:section:unload', event => {
    players.forEach((player, root) => { if (event.target.contains(root)) player.dispose(); });
    if (event.target.querySelector('[data-af-menu]')) document.body.classList.remove('af-modal-open');
  });
  document.querySelector('[data-af-form-result]')?.focus({ preventScroll: true });
})();
